@if (alerts) {
<div class="govuk-width-container">
    <div *ngFor="let alert of alerts" class="govuk-error-summary govbook-error-summary--inverse"
        data-module="govuk-error-summary">
        <div role="alert">
            <h2 class="govuk-error-summary__title">
                There is a problem
            </h2>
            <div class="govuk-error-summary__body">
                <ul aria-label="Error message" class="govuk-list govuk-error-summary__list">
                    <li [innerHTML]="alert.message"></li>
                </ul>
            </div>
        </div>
    </div>
</div>
}